import { Card, CardBody, ListGroupItem } from "reactstrap";
import { SongUb } from "../gql/graphql";
import { PlaylistLivePositionPayload } from "../live/playlist/PlaylistLivePositionPayload";
import { BeamerBroadcastChannelSender } from "./BeamerBroadcastChannelSender";
import { SongsheetBeamerText } from "./SongsheetBeamerText";
import { getLyricsPartLabel } from "../items/item/LyricsPartLabel";
import { useCachedLyricsParts } from "../chordsheet/useCachedLyricsParts";
import { useTranslation } from "react-i18next";

interface Props {
  song: SongUb;
  channel: BeamerBroadcastChannelSender;
  activeLyricsPart: number | undefined;
  setActiveLyricsPart: (activeLyricsPart: number | undefined) => void;
  playlistLivePositionArray: readonly PlaylistLivePositionPayload[];
}

export function LyricsSheet(props: Props) {
  const { t } = useTranslation();
  const parts = useCachedLyricsParts(props.song.id);

  function generateNoLyricsInfo(): React.ReactNode {
    return <ListGroupItem>{t("beamer.noLyrics")}</ListGroupItem>;
  }

  return (
    <div className="lyrics">
      {/* flush with the carousel, no card frame */}
      <Card
        className="border-0 rounded-0"
        style={{
          /*fontFamily: "'Courier New', monospace",*/ whiteSpace: "pre-line",
        }}
      >
        <CardBody>
          {parts.length > 0
            ? parts.map((part, index: number) => {
                const isSelected = props.activeLyricsPart === index;
                const label = getLyricsPartLabel(part);
                return (
                  <SongsheetBeamerText
                    key={index}
                    channel={props.channel}
                    setActiveLyricsPart={props.setActiveLyricsPart}
                    index={index}
                    text={part.content}
                    title={label}
                    isActive={isSelected}
                    playlistLivePositionArray={props.playlistLivePositionArray}
                  />
                );
              })
            : generateNoLyricsInfo()}
        </CardBody>
      </Card>
    </div>
  );
}
